export const env = { apiBase: '/api', wsPath: '/ws/events' } as const;
